// extracted by mini-css-extract-plugin
export default {"root":"tweet-not-found_root__xo9DE"};